<template>
    <div id='calendar'></div>
</template>

<script>
    import c3 from 'c3'
    import d3 from 'd3'
    var chart = {};

    export default {
        replace: true,
        data: function() {
            return {}
        },
        props: ['resources'],
        watch: {
            'data': function(val) {
                this.chart.load({columns: val});
            }
        },
        mounted: function() {

            const el = this.$el;

            var that = this;

            $(this.$el).fullCalendar({
                schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                now: moment().format('YYYY-MM-DD'),
                editable: true,
                aspectRatio: 1,
                scrollTime: '00:00',
                header: {
                    left: 'today prev,next',
                    center: 'title',
                    right: ''
                },
                resourceAreaWidth: "115px",
                droppable: true, // this allows things to be dropped onto the calendar
                defaultView: 'timelineWeek',
                slotDuration: {day: 1},
                weekends: false,
                resources: this.resources,
                events: process.env.VUE_APP_API_URL+'/calendar/events',
                eventBackgroundColor: '#fff',
                eventBorderColor: 'grey',
                eventTextColor: 'grey',
                eventRender: function(event, element) {
                    element.popover({
                                title: '<span class="label label-primary float-right">'+event.project+'</span><span style="font-size: 12px;color: grey;">Estimated '+event.estimate+' hrs</span>',
                                placement: 'auto right',
                                html:true,
                                content: '<div class="row" style="font-size:12px;"><div class="col-sm-12">'+event.title+'</div></div><br><div class="row" style="font-size:12px;"><div class="col-sm-12" style="font-style:italic;color:lightgrey">'+event.story+'</div></div><div class="text-center"><div class="m-t-xs btn-group"><a class="btn btn-xs btn-white"><i class="fa fa-times red"></i> Unschedule </a><a class="btn btn-xs btn-white"><i class="fa fa-pied-piper-alt"></i> Story</a><a class="btn btn-xs btn-white"><i class="fa fa-tasks"></i> Task</a></div></div>',
                                container:'body',
                                animation: true
                            });

                    element.find('.fc-title').text('['+event.estimate+'] '+ event.title);
                },
                resourceRender: function (event, element) {
                    element.find('span.fc-cell-text').html(element.find('span.fc-cell-text').text());
                },
                drop: function(date, jsEvent, ui, resourceId) {
                    $(this).trigger('caldrop', {'resource_id': resourceId, 'date': date.format()});
                },
                eventReceive: function(event) { // called when a proper external event is dropped
                },
                eventDrop: function(event) { // called when an event (already on the calendar) is moved

                    client({path: '/tasks/'+event.id, entity: {'id': event.id, 'owner_id': event.resourceId, 'due': event.start.format()}, mehod: 'PUT'}).then(
                            function(response) {

                            }, function(response) {

                            }
                        )
                },
                viewRender: function(view, element) {
                    //, 'end': view.end.format('YYYY-MM-DD')});
                },
                resourceRender: function(resourceObj, labelTds, bodyTds) {


                    labelTds.css('width', "151px");

                    labelTds.find('.fc-cell-content').before('<span style="width:10px;float: left;height: 100%;background-color: '+resourceObj.eventBackgroundColor+';"></span>')
                }

            });
        }
    }
</script>
